import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationResponse } from '../../../../../api';

@Component({
  selector: 'base-notification-list-item',
  templateUrl: './base-notification-list-item.component.html',
})
export class BaseNotificationListItemComponent {
  @Input({ required: true }) notification: NotificationResponse;
  @Output() readNotification: EventEmitter<{ event: Event; notification: NotificationResponse }> = new EventEmitter<{
    event: Event;
    notification: NotificationResponse;
  }>();

  markNotificationAsRead(event: Event, notification: NotificationResponse): void {
    this.readNotification.emit({ event, notification });
  }
}
